'use strict';

wbApp.filter('gender', ['$translate', function ($translate) {
    return function (input) {
        return input === 'F'
            ? $translate.instant('TXT_VAL_FEMALE')
            : $translate.instant('TXT_VAL_MALE');
    };
}]);